import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    status: {
      color: theme.palette.success.main,
    },
  }),
);

export default useStyles;
